import { UserState } from "../types/user-state/user-state.interface";
import store, { RootState } from "../../../redux/store";
import { createSelector } from "reselect";
import { UserData, UserEmailData } from "../../../pages/login/types/user-data.interface";
import * as actions from "../store/user.actions";

const getUserState = (rootState: RootState): UserState => rootState.user;

export const getUser = createSelector(getUserState, (state: UserState) => state.profile);

export const getUserId = createSelector(getUserState, (state: UserState) => state.profile.id);

export const getUserGroup = createSelector(
  getUserState,
  (state: UserState) => state.profile.groups
);

export const getProfile = createSelector(getUserState, (state: UserState) => state.profile);

export function login(userData: UserData) {
  store.dispatch(actions.login(userData));
}

export function logout() {
  store.dispatch(actions.logout());
}

export function fetchUserData(userId: number) {
  store.dispatch(actions.fetchUserData(userId));
}

export function resetPassword(userData: UserEmailData) {
  store.dispatch(actions.resetPasswordRequest(userData));
}
